module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/company-profile-banner-image.1d57a69e.jpg";